import notifiers from "../global/constants/NotificationConstants";
import { isTruthy, openErrorNotification } from "../helpers/methods";

const toError = (message: any) => {
  const text =
    typeof message === "string"
      ? message
      : message != null
        ? (() => {
            try {
              return JSON.stringify(message);
            } catch {
              return String(message);
            }
          })()
        : notifiers.GENERIC_ERROR;
  return new Error(text || notifiers.GENERIC_ERROR);
};

const customErrorHandler = (response: any, error: any = "") => {
  if (response?.data) return;
  if (error) {
    const { message } = error;
    if (message?.settings?.success === 0) {
      openErrorNotification(
        isTruthy(message?.settings?.message)
          ? message?.settings?.message
          : notifiers.GENERIC_ERROR
      );
      return false;
    } else return true;
  } else {
    if (response?.message?.settings?.success === 0) {
      throw toError(response?.message?.settings?.message);
    } else if (response?.message?.success === 0) {
      throw toError(response?.message);
    } else if (response?.success === 0) {
      throw toError(response?.message);
    }
  }
};

export default customErrorHandler;
